import React from 'react';

interface SubSectionProps {
  title: string;
  content: string;
}

const SubSection: React.FC<SubSectionProps> = ({ title, content }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-6 mb-8 w-full max-w-6xl">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">{title}</h2>
      <p className="text-gray-700">{content}</p>
    </div>
  );
};

export default SubSection;
